import { Injectable } from '@angular/core';
import { filter, map, Observable, take, tap } from 'rxjs';
import { ProjectResponseGetById, UpdateProjectRequestPartial } from '@nx-customer-apps/api-planning-projects';
import { CountryCode } from '@nx-customer-apps/shared/enums';
import { GlobalSpinnerService } from '../../core';
import { GlobalStore } from '../../state/global/global.store';
import { ProjectStore } from '../../state/project/project.store';
import { HeatPumpIntermediaryMapper } from './heat-pump-intermediary.mapper';

@Injectable({
    providedIn: 'root'
})
export class HeatPumpIntermediaryService {
    constructor(
        private mapper: HeatPumpIntermediaryMapper,
        private globalSpinnerService: GlobalSpinnerService,
        private projectStore: ProjectStore,
        private globalStore: GlobalStore
    ) {}

    public isSubsidyPossible(project: ProjectResponseGetById): boolean {
        return project.countryCode === CountryCode.DE;
    }

    public saveHeatPumpIntermediary(options: {
        migration?: boolean;
        variantId: string;
    }): Observable<{ project: ProjectResponseGetById; request: UpdateProjectRequestPartial }> {
        return this.globalStore.state$.pipe(
            filter(state => Boolean(state.project.selectedProject)),
            map(state => ({
                project: state.project.selectedProject!,
                request: this.mapper.stateToProjectRequest(state)
            })),
            tap(({ project, request }) => {
                this.globalSpinnerService.next({
                    isShown: true,
                    loadingText: 'LOADER.TEXT.UPDATING_PROJECT',
                    loadingSubtext: 'LOADER.SUBTEXT.UPDATING_PROJECT'
                });
                this.projectStore.saveHeatPumpIntermediary({ id: project!.id!, request, variantId: options.variantId });
            }),
            take(1)
        );
    }
}
